export const SINGLE = 'SINGLE';
export const MULTIPLE = 'MULTIPLE';
export const MESSAGE_REQUIRED_FIELD = `Opps! Don't forget to include this`;
export const MESSAGE_INVALID_EMAIL = `Opps! Must be a valid email address`;
export const MESSAGE_FORM_SUBMIT_GENERAL_ERROR = `<p>Uh oh, something’s gone wrong. Try again later or email me directly at <a href="mailto:sophie@liminalpages.com">sophie@liminalpages.com</a>.</p>`;
export const MESSAGE_FORM_SUBMIT_GENERAL_SUCCESS = `<p>Thanks for your message. I’ll get back to you (either by owl post or email) as soon as I can, usually within two working days.</p>`;
export const TWITTER_WIDGETS_URL = 'https://platform.twitter.com/widgets.js';
export const INSTAGRAM_EMBED_URL = '//www.instagram.com/embed.js';
